(() => {
  const root=document.documentElement;
  const standalone=window.matchMedia('(display-mode: standalone)').matches||window.navigator.standalone===true;
  if(standalone){root.classList.add('tl-pwa-standalone');return;}
  const shell=document.querySelector('[data-tl-pwa-install]');
  if(!shell)return;
  const button=shell.querySelector('[data-pwa-install-button]');
  const dismiss=shell.querySelector('[data-pwa-dismiss]');
  const copy=shell.querySelector('[data-pwa-copy]');
  const iosDialog=document.querySelector('[data-pwa-ios-dialog]');
  const ua=navigator.userAgent||'';
  const isIOS=/iPad|iPhone|iPod/.test(ua)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
  const isSafari=isIOS&&/Safari/.test(ua)&&!/CriOS|FxiOS|EdgiOS/.test(ua);
  let promptEvent=null;
  const key='uncle-tl-pwa-dismiss-until-v1';
  const now=Date.now();
  const dismissedUntil=Number(localStorage.getItem(key)||0);
  const canShow=()=>dismissedUntil<now;
  const show=mode=>{
    if(!canShow())return;
    shell.hidden=false;
    if(mode==='ios'){
      copy.textContent='Add Uncle TL’s Playground to your Home Screen for quicker access to Passport, games, music, and stories.';
      button.textContent='How to install';
    }else{
      copy.textContent='Install Uncle TL’s Playground for quicker access to Passport, games, music, and stories.';
      button.textContent='Install';
    }
  };
  const hide=()=>{shell.hidden=true};
  dismiss?.addEventListener('click',()=>{
    localStorage.setItem(key,String(Date.now()+14*24*60*60*1000));
    hide();
  });
  window.addEventListener('beforeinstallprompt',event=>{
    event.preventDefault();
    promptEvent=event;
    show('prompt');
  });
  window.addEventListener('appinstalled',()=>{
    localStorage.removeItem(key);
    hide();
  });
  button?.addEventListener('click',async()=>{
    if(promptEvent){
      promptEvent.prompt();
      try{await promptEvent.userChoice;}catch(e){}
      promptEvent=null;
      hide();
      return;
    }
    if(isSafari){
      if(typeof iosDialog?.showModal==='function')iosDialog.showModal();
      return;
    }
  });
  if(isSafari){
    window.setTimeout(()=>show('ios'),9000);
  }
})();